import { BubbleInnerWidth, brand, white } from '../../../styles/rn';
import { CustomStyleSheet } from '../../../utils/rn/tools';
export default CustomStyleSheet({
  container: {
    flexDirection: 'row'
  },
  orderList: {
    paddingHorizontal: 15
  },
  orderItem: {
    backgroundColor: white,
    borderRadius: 12,
    width: BubbleInnerWidth,
    marginRight: 4,
    marginBottom: 2,
    shadowOffset: {
      width: 0,
      height: 1
    },
    shadowOpacity: 1,
    shadowRadius: 1,
    shadowColor: 'rgba(0, 0, 0, 0.1)',
    elevation: 1
  },
  noMarginRight: {
    marginRight: 0
  },
  selectOrderBtn: {},
  moreOrdersContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: white,
    borderRadius: 12,
    width: 120,
    padding: 12,
    marginBottom: 2,
    shadowOffset: {
      width: 0,
      height: 1
    },
    shadowOpacity: 1,
    shadowRadius: 1,
    shadowColor: 'rgba(0, 0, 0, 0.1)',
    elevation: 1
  },
  moreOrdersImage: {
    width: 32,
    height: 32
  },
  moreOrdersText: {
    marginTop: 12,
    color: brand,
    fontSize: 14,
    lineHeight: 14,
    textAlign: 'center'
  },
  // bigCarousel
  'container-big-carousel': {},
  'orderItem-big-carousel': {
    width: 150,
    borderRadius: 12
  },
  'selectOrderBtn-big-carousel': {
    minWidth: 150
  },
  'moreOrdersContainer-big-carousel': {
    width: 56,
    padding: 4
  },
  // verticalList
  'container-vertical-list': {
    flexDirection: 'column',
    paddingHorizontal: 15
  },
  'orderList-vertical-list': {
    borderRadius: 12,
    overflow: 'hidden',
    width: BubbleInnerWidth
  },
  'orderItem-vertical-list': {
    borderRadius: 0,
    marginBottom: 0,
    shadowOpacity: 0
  },
  'selectOrderBtn-vertical-list': {
    minWidth: 150
  },
  'moreOrdersContainer-vertical-list': {
    margin: 0,
    padding: 0,
    height: 26,
    width: BubbleInnerWidth,
    borderRadius: 0,
    borderBottomEndRadius: 12,
    borderBottomStartRadius: 12
  },
  'moreOrdersText-vertical-list': {
    marginTop: 0,
    fontSize: 12,
    lineHeight: 14
  },
  // twoRowCarousel
  'container-two-row-carousel': {
    flexDirection: 'column'
  },
  'moreOrdersContainer-two-row-carousel': {
    alignSelf: 'flex-start',
    width: 'auto',
    padding: 0,
    maxWidth: BubbleInnerWidth,
    paddingVertical: 7,
    paddingHorizontal: 16,
    borderRadius: 100,
    marginTop: 4,
    marginLeft: 15
  },
  'moreOrdersText-two-row-carousel': {
    marginTop: 0,
    fontSize: 12,
    lineHeight: 14
  },
  twoRowCarouselBottomOrderItem: {
    marginTop: 6
  }
});